export const investNot = (state = {}, action) => {
  switch (action.type) {
    case "INVEST_NOT":
      return action.data;
    case "INVEST_NOT_DEL":
      return {};
    default:
      return state;
  }
};

export const superFundProductIncomes = (state = {}, action) => {
  switch (action.type) {
    case "SUPERFUND_PRODUCT_INCOME":
      return action.data;
    case "SUPERFUND_PRODUCT_INCOME_DEL":
      return {};
    default:
      return state;
  }
};
export const lineData = (state = {}, action) => {
  switch (action.type) {
    case "LINE_DATA":
      return { ...state, ...action.data };
    case "LINE_DATA_DEL":
      return {};
    default:
      return state;
  }
};

export const stopProfitDetail = (state = {}, action) => {
  switch (action.type) {
    case "STOP_PROFIT_DETAIL":
      return { ...state, ...action.data };
    case "STOP_PROFIT_DETAIL_DEL":
      return {};
    default:
      return state;
  }
};

export const strategiesDetails = (state = {}, action) => {
  switch (action.type) {
    case "STRATEGIES_DETAILS":
      return action.data;
    case "STRATEGIES_DETAILS_DEL":
      return {};
    default:
      return state;
  }
};

export const changeFundList = (state = {}, action) => {
  switch (action.type) {
    case "CHANGE_FUND_LIST":
      return action.data;
    case "CHANGE_FUND_LIST_DEL":
      return {};
    default:
      return state;
  }
};

export const userAllIncomeHistory = (state = {}, action) => {
  switch (action.type) {
    case "USER_ALL_INCOME_HISTORY":
      return {...state,...action.data};
    case "USER_ALL_INCOME_HISTORY_DEL":
      return {};
    default:
      return state;
  }
};

export const lineDataLast=(state={},action)=>{
  switch (action.type) {
    case "LINE_DATA_LAST":
      return action.data;
    case "LINE_DATA_LAST_DEL":
      return {};
    default:
      return state;
  }
}

export const allIncomeLast=(state=null,action)=>{
  switch (action.type) {
    case "ALL_INCOME_LAST":
      return action.data;
    case "ALL_INCOME_LAST_DEL":
      return null
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducer/protfolioReducer.js